import axios from "axios"

import { authRequestOptions } from "./auth"

export const getTeams = (id) =>
  new Promise((resolve) => {
    axios
      .get(
        `${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/leagues/${id}/teams`,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch(() => false)
  })

export const getPickems = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/pickems/`, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject(error))
  })

export const getPickem = (id) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/pickems/${id}/`, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject(error))
  })

export const getSheet = (id, sheetId, errorCallback) =>
  new Promise((resolve) => {
    axios
      .get(
        `${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/pickems/${id}/sheets/${sheetId}/`,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch(() => errorCallback())
  })

export const getCurrentSheet = (id) =>
  new Promise((resolve, reject) => {
    axios
      .get(
        `${
          process.env.GATSBY_APP_ENGINE_BASE_URL
        }/api/pickems/${id}/sheets/current/`,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject(error))
  })

export const putCurrentSheet = (id, body) =>
  new Promise((resolve, reject) => {
    axios
      .put(
        `${
          process.env.GATSBY_APP_ENGINE_BASE_URL
        }/api/pickems/${id}/sheets/current/`,
        body,
        authRequestOptions()
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject(error))
  })

export const getLeaderboard = (id, sheet) =>
  new Promise((resolve, reject) => {
    axios
      .get(
        `${
          process.env.GATSBY_APP_ENGINE_BASE_URL
        }/api/pickems/${id}/${sheet ? `sheets/${sheet}/` : ""}leaderboards/`,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject(error))
  })
